import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { RQ_LATEST_DEPLOY_PROCESS, RQ_LATEST_DEPLOY_PROCESS_POILLING_INTERVAL } from 'Utils';
import { getLatestDeployProcess } from 'Services';

function useGetLatestDeployProcess(
    shouldPoll: boolean = false,
    shouldFetch?: boolean,
    onSuccess?: (data: DeploymentProcess) => void,
    onError?: (err: unknown) => void
) {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_LATEST_DEPLOY_PROCESS, templateRepositoryId],
        () => getLatestDeployProcess(templateRepositoryId!),
        {
            enabled: !!(templateRepositoryId && templateRepositoryId > 0 && shouldFetch),
            // never use cache as we want to get a real-time update on the ongoing deployment process
            cacheTime: 0,
            refetchInterval: shouldPoll ? RQ_LATEST_DEPLOY_PROCESS_POILLING_INTERVAL : undefined,
            onSuccess: (data) => onSuccess?.(data),
            onError: (err) => onError?.(err)
        }
    );
}

export default useGetLatestDeployProcess;
